import React, { useState } from 'react';
import { gql } from '@apollo/client';
import IdInput from 'components/Filter/IdInput';
import { BooleanField, Datagrid, BooleanInput, DateInput } from 'react-admin';
import List from 'components/List';
import StateInput from 'components/StateInput';
import LinkField from 'components/LinkField';
import DateTimeField from 'components/DateTimeField';
import LocationTypeInput from 'components/LocationTypeInput';
import PositionInput from 'components/PositionInput';
import PercentField from 'components/PercentField';
import MoneyField from 'components/MoneyField';
import { getSettingsQuery } from '../utils/getSettingsQuery';
import { SettingsNestedOperatorSelect } from 'components/SettingsNestedOperatorSelect';

const StateLocationTypePositionRateSettingListFilters = [
  <IdInput />,
  <PositionInput emptyText="All" alwaysOn />,
  <StateInput label="State" source="state_id" alwaysOn resettable />,
  <LocationTypeInput label="Location Type" source="location_type_id" alwaysOn resettable />,
  <BooleanInput alwaysOn source="active" />,
  <DateInput alwaysOn label="Updated after" source="search.updated_at_from" />,
];

const StateLocationTypePositionRateSettingList = () => {
  const [settingsNestedOperator, setSettingsNestedOperator] = useState('ten99');

  return (
    <List filters={StateLocationTypePositionRateSettingListFilters} exporter={false}>
      <SettingsNestedOperatorSelect
        setSettingsNestedOperator={setSettingsNestedOperator}
        settingsNestedOperator={settingsNestedOperator}
      />
      <Datagrid bulkActionButtons={false}>
        <LinkField label="ID" source="id" />
        <LinkField label="State" source="state.name" sortBy="state_name" />
        <LinkField label="Location Type" source="location_type.label" sortBy="location_type_name" />
        <LinkField label="Position" source="position.display_name" sortBy="position_name" />
        <LinkField label="Specialty" source="specialty.label" sortBy="specialty_name" />
        <MoneyField
          label="Charge 8hr Rate"
          source={`with_markup_settings.${settingsNestedOperator}.charge_rate_cents`}
          sortBy={`${settingsNestedOperator.replace('.', '_')}_charge_rate_cents`}
          blankIfNull
        />
        <PercentField
          label="Location Type Markup"
          source="settings.location_type_markup"
          sortBy="location_type_markup"
          blankIfNull
        />
        <BooleanField source="active" />
        <DateTimeField
          format="MM/dd/yyyy HH:mm"
          source="updated_at"
          timeZone="America/Los_Angeles"
        />
      </Datagrid>
    </List>
  );
};

StateLocationTypePositionRateSettingList.query = gql`
  query stateLocationTypePositionRateSettings(
    $input: StateLocationTypePositionRateSettingQueryInput
  ) {
    _stateLocationTypePositionRateSettingsMeta(input: $input) {
      count
    }
    stateLocationTypePositionRateSettings(input: $input) {
      id
      active
      state {
        id
        name
      }
      location_type {
        id
        label
      }
      position_id
      position {
        id
        display_name
      }
      ${getSettingsQuery(true)}
      specialty_id
      specialty {
        id
        label
      }
      state_id
      updated_at
      with_markup_settings {
        ten99 {
          charge_rate_cents
        }
        w2 {
          local {
            charge_rate_cents
          }
          travel {
            charge_rate_cents
          }
        }
      }
    }
  }
`;

export default StateLocationTypePositionRateSettingList;
